<template>
  <div class="model-frame">
    <el-row>
      <div class="model-header">
        <h2>Thu tiền, mở kì học, xem điểm</h2>
        <!-- <el-button @click="createModel" size="small" type="info" class="btn-create">Thêm mới</el-button> -->
      </div>
    </el-row>
    <el-row>
      <div class="model-filter">
        <el-col :span="8">
          <div class="input-daterange">
            <el-date-picker
              v-model="filter.date"
              @change="changeDateStatistic"
              type="daterange"
              value-format="yyyy-MM-dd"
              format="dd/MM/yyyy"
              range-separator="tới"
              start-placeholder="Ngày bắt đầu"
              end-placeholder="Ngày kết thúc"
              :picker-options="pickerOptions2">
            </el-date-picker>
          </div>
        </el-col>
        <el-col :span="2">
          <el-popover
            placement="bottom"
            title="Sắp xếp theo"
            width="400"
            trigger="click"
            content="Nội dung">
            <div class="model-filter-radio"
              v-for="(item, index) in sort"
              :key="index">
              <span>{{ item.groupName }}:</span>
              <el-radio
                v-for="(itemSort, index_itemSort) in item.groupFiled"
                :key="index_itemSort"
                v-model="filter.sort" :label="itemSort.label">{{ itemSort.text }}</el-radio>
            </div>
            <span class="model-filter-search" slot="reference">
              <i class="fas fa-sort"></i>
            </span>
          </el-popover>
        </el-col>
        <el-col :span="8">

        </el-col>
        <el-col :span="5">
          <el-input
            placeholder="Tìm kiếm ..."
            class="input-seach"
            clearable
            :prefix-icon="searching ? 'fas fa-spinner fa-spin' : 'el-icon-search'"
            v-model="filter.q">
          </el-input>
        </el-col>
      </div>
    </el-row>
    <el-row :gutter="10">
      <div class="model-filter">
        <el-col :span="5">
          <el-select v-model="filter.school_id" filterable clearable placeholder="Chọn trường" class="input-select">
            <el-option
              v-for="item in lists.listSchool"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="filter.level_id" filterable clearable placeholder="Chọn phân hệ" class="input-select">
            <el-option
              v-for="item in lists.listLevel"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-select v-model="filter.facult_id" filterable clearable placeholder="Chọn chuyên ngành" class="input-select">
            <el-option
              v-for="item in lists.listFacult"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-select v-model="filter.class_pro_id" filterable clearable placeholder="Chọn lớp" class="input-select">
            <el-option
              v-for="item in lists.listClassPro"
              :key="item.id"
              :label="item.code"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-select v-model="filter.staff_id" filterable clearable placeholder="Chọn nhân viên xử lý" class="input-select">
            <el-option
              v-for="item in lists.listStaff"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
      </div>
    </el-row>
    <el-row>
      <div class="model-pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="table.pagination.per_page"
            :pager-count="table.pagination.count"
            :current-page="table.pagination.current_page"
            :total="table.pagination.total"
            @current-change="changeCurrentPage">
          </el-pagination>
          <div style="padding-left: 5px">
            Hiển thị tới Đăng kí <strong>{{ table.meta_pagination }}</strong> / Tổng số: <strong>{{ table.pagination.total }}</strong> Đăng kí
          </div>
      </div>
    </el-row>
    <el-row>
      <div class="model-table">
        <el-table
          v-loading="loading"
          border
          :data="table.database"
          style="width: 100%">
          <el-table-column
            label="#"
            type="index"
            width="40">
          </el-table-column>
          <el-table-column
            prop="name"
            label="Học viên"
            width="200">
            <template slot-scope="scope">
              <div class="courses-info">
                <strong style="color: green">{{ scope.row.class_pro_code }}</strong>
                <span style="font-weight: bold">{{ scope.row.user_name }}</span>
                <span>{{ scope.row.user_email }} - {{ scope.row.id }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Thông tin">
            <template slot-scope="scope">
              <div class="courses-info">
                <span v-if="scope.row.school_id">
                  <strong>Trường: </strong>
                  {{ scope.row.school_text }}
                </span>
                <span v-if="scope.row.level_id">
                  <strong>Phân hệ: </strong>
                  {{ scope.row.level_text }}
                </span>
                <span v-if="scope.row.facult_id">
                  <strong>Chuyên ngành: </strong>
                  {{ scope.row.facult_text }}
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            width="220"
            label="Tên miền">
            <template slot-scope="scope">
              <p style="font-weight: bold" v-if="scope.row.domain_name">{{ scope.row.domain_name }}</p>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="Nhân viên xử lý"
            width="200">
            <template slot-scope="scope">
              <div class="courses-info">
                <span style="font-weight: bold">{{ scope.row.staff_name }}</span>
                <span>{{ scope.row.staff_email }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="Số tiền"
            width="100">
            <template slot-scope="scope">
              <div class="courses-info">
                <span style="font-weight: bold">{{ scope.row.total_money_format }} đ</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="Đã thu"
            width="100">
            <template slot-scope="scope">
              <div class="courses-info">
                <span style="font-weight: bold">{{ scope.row.total_money_done_format }} đ</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            width="150"
            label="Timeline">
            <template slot-scope="scope">
              <el-progress :percentage="scope.row.total_done"></el-progress>
            </template>
          </el-table-column>
          <el-table-column
            width="170"
            label="Thời gian">
            <template slot-scope="scope">
                <span>{{ scope.row.created_at }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Hành động"
            width="200"
            header-align="center">
            <template slot-scope="scope">
              <div class="module-action">
                <el-tooltip effect="dark" content="Xem điểm" placement="top">
                  <span @click="showScore(scope.row)">
                    <i class="far fa-window-restore"></i>
                  </span>
                </el-tooltip>
                <el-tooltip effect="dark" content="Thu tiền" placement="top" v-if="accountInfo.user_type == 1">
                  <span @click="addPayment(scope.row)">
                    <i class="fas fa-download"></i>
                  </span>
                </el-tooltip>
                <el-tooltip effect="dark" content="Mở khóa học" placement="top">
                  <span @click="openTerm(scope.row)">
                   <i class="far fa-folder-open"></i>
                  </span>
                </el-tooltip>
                <el-tooltip effect="dark" content="Lịch sử" placement="top">
                  <span @click="showLog(scope.row)">
                    <i class="fas fa-history"></i>
                  </span>
                </el-tooltip>
                <el-tooltip effect="dark" content="Xóa" placement="top" v-if="accountInfo.user_type == 1">
                  <span @click="confirmDeleteModel(scope.row)">
                    <i class="far fa-trash-alt icon-delete"></i>
                  </span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-row>
    <el-dialog
      :close-on-click-modal="false"
      :title="'Thu tiền của ' + classUser.modelData.user_name + ' - ' + classUser.modelData.user_email + ' - ' + classUser.modelData.class_pro_code"
      :visible.sync="classUser.dialogVisible"
      width="45%">
      <div class="class-pro-list">
        <h3>Lớp: {{ classUser.modelData.class_pro_code }}</h3>
        <h3>Tổng tiền cần nộp: <strong>{{ classUser.modelData.total_money_format }} đ</strong></h3>
        <h3>Tổng tiền đã thu: <strong>{{ classUser.modelData.total_money_done_format }} đ</strong></h3>
        <h3>Nhập số tiền nộp:</h3>
        <el-input type="age" v-model.number="classUser.modelPush.money" class="input-seach" auto-complete="off">
          <template slot="append">{{ classUser.modelPush.money | vnd }}</template>
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button @click="classUser.dialogVisible = false" size="small">Cancel</el-button>
          <el-button
            :disable="!canSubmit"
            :loading="!canSubmit"
            type="primary" @click="updatePaymentToServer"  size="small">OK</el-button>
        </span>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :title="'Lịch sử hoạt động của ' + classUser.modelData.user_name + ' - ' + classUser.modelData.user_email"
      :visible.sync="classUser.dialogVisibleLog"
      width="45%">
      <el-tabs v-model="activeName">
        <el-tab-pane label="Gán lớp, mở kì học" name="first">
          <div class="log-class-user" v-if="classUser.modelData.logs">
            <div
              class="item"
              :key="index_1"
              v-for="(item, index_1) in classUser.modelData.logs">
              <div v-if="item.action === 'update-school-id'">
                <strong>{{ item.user_request_name }} - {{ item.user_request_email }}</strong> đã gán trường và nhân viên hỗ trợ cho học viên
              </div>
              <div v-if="item.action === 'update-class-pro-id'">
                <strong>{{ item.user_request_name }} - {{ item.user_request_email }}</strong> đã gán lớp {{ item.class_pro_code }}
              </div>
              <div v-if="item.action === 'update-payment-status-v2'">
                <strong>{{ item.user_request_name }} - {{ item.user_request_email }}</strong> mở khóa học kì {{ item.term_open }}
              </div>

              <div>
                <span class="time">{{ item.time }}</span>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Thu tiền" name="second">
          <div class="log-class-user" v-if="classUser.modelData.logs">
            <div
              class="item"
              :key="index_2"
              v-for="(item, index_2) in historyPaymentOfClassUser">
              <strong>{{ item.user_confirm_name }} - {{ item.user_confirm_email }}</strong> đã thu <span style="color:green">{{ item.money_format }} đ</span>
              <div>
                <span class="time">{{ item.time }}</span>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button @click="classUser.dialogVisibleLog = false" size="small">Cancel</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :title="'Mở khóa kì học cho học viên ' + classUser.modelData.user_name + ' - ' + classUser.modelData.user_email + ' - ' + classUser.modelData.class_pro_code"
      :visible.sync="classUser.dialogVisibleOpen"
      width="45%">
      <div class="class-user-register">
        <div class="row">
          <div class="col-md-12 col-12">
            <div>
              <div v-for="(item, index_1) in classUser.courses_default" :key="item.key">
                <div class="main-term d-flex align-items-center justify-content-between">
                  <div>
                    <span class="text">Kì {{ index_1 + 1 }}</span>
                    <!-- <span>Tổng tiền : <strong style="color: red">{{ item.total_money | vnd }}</strong></span> -->
                  </div>

                  <span v-if="index_1 < classUser.modelData.payment_status">Đã mở khóa</span>
                  <el-button
                    :disable="!canSubmit"
                    :loading="!canSubmit"
                    @click="submitForm(item, index_1)"
                    v-if="classUser.modelData.payment_status == index_1"
                    type="success" size="mini">Mở khóa kì {{ index_1 + 1 }}</el-button>
                </div>
                <div class="course-terms">
                  <div
                    :key="item2.course_id"
                    class="d-flex justify-content-between"
                    v-for="(item2) in item.course_terms">
                    <span>{{ item2.course_position }} . {{ item2.course_name }}</span>
                    <span>{{ item2.course_code }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="classUser.dialogVisibleOpen = false" size="small">Cancel</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { head, findIndex } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Promotions',
  metaInfo () {
    return {
      title: 'Thu tiền, mở kì học'
    }
  },
  data () {
    return {
      activeName: 'first',
      loading: false,
      searching: false,
      canSubmit: true,
      filter: {
        q: '',
        status: 1,
        date: '',
        school_id: '',
        level_id: '',
        facult_id: '',
        staff_id: '',
        page: 1,
        limit: 15,
        sorted: ''
      },
      pickerOptions2: {
        shortcuts: [
          {
            text: 'Hôm nay',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 0)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '3 ngày trước',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 3)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '7 ngày trước',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '14 ngày trước',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 14)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '1 Tháng trước',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '3 Tháng trước',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      sort: [
        {
          groupName: 'Không sắp xếp',
          groupFiled: [
            { label: '', text: 'Không sắp xếp' }
          ]
        },
        {
          groupName: 'Thời gian',
          groupFiled: [
            { label: 'created_at:-1', text: 'Tăng dần' },
            { label: 'created_at:1', text: 'Giảm dần' }
          ]
        }
      ],
      lists: {
        listStatus: [
          {key: 1, value: 'Kích hoạt'},
          {key: 0, value: 'Chưa kích hoạt'}
        ],
        listCategoryBlogs: [
          {key: 1, value: 'Menu chính'},
          {key: 2, value: 'Footer cột Giới thiệu'},
          {key: 3, value: 'Footer cột Cộng tác viên Affiliate'},
          {key: 4, value: 'Footer cột Chính sách'}
        ],
        listSchool: [],
        listLevel: [],
        listFacult: [],
        listSpecialized: [],
        listKey: [],
        listTeacher: [],
        listStaff: [],
        listClassPro: []
      },
      table: {
        database: [],
        meta_pagination: 0,
        pagination: {
          total: 0,
          count: 0,
          per_page: 0,
          current_page: 1,
          total_pages: 0
        },
        timer: {}
      },
      classUser: {
        dialogVisible: false,
        dialogVisibleLog: false,
        dialogVisibleOpen: false,
        modelData: {},
        modelPush: {
          money: 1000000
        },
        courses_default: {}
      },
      historyPaymentOfClassUser: {}
    }
  },
  computed: {
    ...mapGetters('account', ['accountInfo'])
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchDatabaseModel()
    this.fetchSchool()
    this.fetchStaff()
  },
  methods: {
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'class-users-index', text: 'Thu tiền, mở kì học' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút tạo Model
    createModel () {
      this.$router.push({name: 'class-users-create'})
    },
    // Xem chi tiết
    showModel (model) {
      this.$router.push({name: 'class-users-v2-show', params: {id: model.id}})
    },
    // Xem điểm
    showScore (model) {
      // this.$router.push({name: 'class-users-v2-show-score', params: {id: model.id}})
      let routeData = this.$router.resolve({name: 'class-users-v2-show-score', params: {id: model.id}})
      window.open(routeData.href, '_blank')
    },
    // Fetch dữ liệu
    fetchDatabaseModel () {
      this.loading = true
      axios.post('class-users-v2', this.filter).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.table.database = response.data
            this.table.pagination = response.meta.pagination
            this.caculaterMetaPagination()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchSchool () {
      axios.get('schools', {params: {'status': 1, 'limit': -1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listSchool = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchLevel () {
      let data = {
        'status': 1,
        'limit': -1,
        'school_id': this.filter.school_id
      }
      axios.get('levels', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listLevel = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchFacult () {
      let data = {
        'status': 1,
        'limit': -1,
        'school_id': this.filter.school_id,
        'level_id': this.filter.level_id
      }
      axios.get('facults', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listFacult = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchSpecialized () {
      let data = {
        'status': 1,
        'limit': -1,
        'school_id': this.filter.school_id,
        'level_id': this.filter.level_id,
        'facult_id': this.filter.facult_id
      }
      axios.get('specializeds', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listSpecialized = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchStaff () {
      axios.post('class-users/get-list-staff-v2').then(response => {
        switch (response.code) {
          case 200:
            this.lists.listStaff = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchListClassPro () {
      let data = {
        'status': 1,
        'limit': -1,
        'school_id': this.filter.school_id,
        'level_id': this.filter.level_id,
        'facult_id': this.filter.facult_id
      }
      axios.get('class-pros', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listClassPro = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tính trường số bản ghi xem nó đang hiện đến bao nhiêu
    caculaterMetaPagination () {
      if (this.table.pagination.current_page === this.table.pagination.total_pages) {
        this.table.meta_pagination = (this.table.pagination.current_page - 1) * this.table.pagination.per_page + this.table.pagination.count
      } else {
        this.table.meta_pagination = this.table.pagination.current_page * this.table.pagination.per_page
      }
    },
    // confirmDeleteModel
    confirmDeleteModel (model) {
      this.$confirm('Xác nhận xóa học viên lớp ' + model.class_pro_code + ' của: ' + model.user_email, 'Warning', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.deleteModel(model)
      }).catch(() => {

      })
    },
    // Xóa bản ghi
    deleteModel (model) {
      axios.delete('class-users/' + model.id).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Xóa bản ghi thành công',
              type: 'success'
            })
            let indexDelete = this.findIDLocal(model)
            if (indexDelete > -1) {
              this.table.database.splice(indexDelete, 1)
            }
            break
          case 404:
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: 'Không tìm thấy tài nguyên',
              type: 'warning'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tìm ID ở database Local để xóa đi
    findIDLocal (model) {
      let index = findIndex(this.table.database, function (o) {
        return o.id === model.id
      })
      return index
    },
    // Thay đổi Current Page
    changeCurrentPage (currentPage) {
      this.filter.page = currentPage
      this.fetchDatabaseModel()
    },

    // Nạp tiền:
    addPayment (model) {
      this.classUser.modelData = model
      this.classUser.dialogVisible = true
    },
    updatePaymentToServer () {
      this.canSubmit = false
      let data = {
        'money': this.classUser.modelPush.money,
        'class_user_id': this.classUser.modelData.id
      }
      axios.post('add-money-for-user-class-v2', data).then(response => {
        this.canSubmit = true
        this.classUser.dialogVisible = false
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Nạp thành công',
              type: 'success'
            })
            this.fetchDatabaseModel()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },

    // Show log:
    showLog (model) {
      this.classUser.modelData = model
      this.classUser.dialogVisibleLog = true

      // Fetch lịch sử nạp tiền
      this.activeName = 'first'
      this.historyPaymentOfClassUser = {}
      axios.post('class-users/get-list-payment-v2/' + this.classUser.modelData.id).then(response => {
        switch (response.code) {
          case 200:
            this.historyPaymentOfClassUser = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },

    // Mở kì học
    openTerm (model) {
      this.classUser.courses_default = {}
      this.classUser.modelData = model
      this.classUser.dialogVisibleOpen = true
      this.fetchFacultTerm()
    },
    fetchFacultTerm () {
      axios.get('facults/' + this.classUser.modelData.facult_id + '?showConent=true').then(response => {
        switch (response.code) {
          case 200:
            this.classUser.courses_default = response.data.courses_default
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    submitForm (item, index) {
      let text = 'Mở khóa các môn học của kì ' + (index + 1)
      // console.log(text);
      this.$confirm(text, 'Xác nhận', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.storeModel(item, index)
      }).catch(() => {

      })
    },
    storeModel (item, index) {
      this.canSubmit = false
      axios.post('class-users/update-payment-status-v2/' + this.classUser.modelData.id).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Mở kì thành công',
              type: 'success'
            })
            this.classUser.dialogVisibleOpen = false
            this.classUser.courses_default = {}
            this.fetchDatabaseModel()
            break
          case 422:
            this.canSubmit = true
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.canSubmit = true
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },

    // Bộ lọc thời gian
    changeDateStatistic () {
      this.fetchDatabaseModel()
    }
  },
  watch: {
    'filter.status': function () {
      this.fetchDatabaseModel()
    },
    'filter.q': function () {
      this.searching = true
      clearTimeout(this.timer)
      let _this = this
      this.timer = setTimeout(function () {
        _this.searching = false
        _this.fetchDatabaseModel()
      }, 800)
    },
    'filter.sort': function () {
      this.fetchDatabaseModel()
    },
    'filter.school_id': function () {
      this.filter.level_id = ''
      this.filter.facult_id = ''
      this.filter.specialized_id = ''

      this.lists.listLevel = []
      this.lists.listFacult = []
      this.lists.listSpecialized = []

      if (this.filter.school_id) {
        this.fetchLevel()
        this.fetchListClassPro()
      }
      this.fetchDatabaseModel()
    },
    'filter.level_id': function () {
      this.filter.facult_id = ''
      this.filter.specialized_id = ''

      this.lists.listFacult = []
      this.lists.listSpecialized = []

      if (this.filter.level_id) {
        this.fetchFacult()
        this.fetchListClassPro()
      }

      this.fetchDatabaseModel()
    },
    'filter.facult_id': function () {
      this.fetchDatabaseModel()
      this.fetchListClassPro()
    },
    'filter.staff_id': function () {
      this.fetchDatabaseModel()
    },
    'filter.class_pro_id': function () {
      this.fetchDatabaseModel()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-filter-search {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #efefef;
  border-radius: 2px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}
.model-filter-radio {
  margin-bottom: 10px;
}
.model-filter-radio span {
  margin-right: 20px;
  width: 135px;
  display: inline-block;
}
.course-image {
  width: 150px;
  border-radius: 2px;
}
.courses-info {
  display: flex;
  flex-direction: column;
}
.courses-info span {
  margin-bottom: 5px;
}

/*class-pro*/
.class-pro-list {
  min-height: 100px;
}
.class-pro-item {
  border-bottom: 1px solid #f1f1f1;
  padding: 5px 10px;
  margin-bottom: 5px;
  cursor: pointer;
}
.class-pro-item:hover {
  background-color: #f8f8f8;
}
.class-pro-item-none {
    border-bottom: none;
}

.log-class-user .item {
  margin-bottom: 10px;
}
.log-class-user .time {
  color: #7d7d7d;
}

.class-user-register {
  min-height: 350px;
}

.main-term {
  background-color: #f2f2f2;
  margin-bottom: 10px;
  margin-top: 10px;
  padding: 5px 10px;
}
.main-term .text {
  font-weight: bold;
  font-size: 18px;
  margin-right: 40px;
}

.main-term .el-input {
  width: 250px;
  margin-left: 10px;
}
.course-terms {
  padding-left: 80px;
  padding-right: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/class-users-v2/Index.vue